import { useCallback } from 'react';
import { createReport } from '../create';
import { decryptReport } from '../decrypt';
import { updateReportStatus } from '../update';

export const useReportActions = () => {
    return {
        createReport: useCallback(createReport, []),
        decryptReport: useCallback(decryptReport, []),
        updateReportStatus: useCallback(updateReportStatus, []),
    };
};
